<script>
export default {
  created() {
    var uid = this.$route.params.uid
    var token = this.$route.query.token

    this.$store
      .dispatch("auth/verifyEmail", { userId: uid, token: token })
      .then(
        function(response) {
          this.$store.dispatch("auth/logout")
          this.$router.push({
            name: "Login",
            params: {
              alert: {
                message: this.$t("Messages.__SuccessfullyVerified"),
                type: "success"
              }
            }
          })
        }.bind(this)
      )
      .catch(
        function(error) {
          this.$store.dispatch("auth/logout")
          this.$router.push({
            name: "Login",
            params: {
              email: null,
              alert: {
                message: error.message,
                type: "error"
              }
            }
          })
        }.bind(this)
      )
  }
}
</script>
